import { render, staticRenderFns } from "./suporte-pacientes.vue?vue&type=template&id=f1b92642"
import script from "./suporte-pacientes.vue?vue&type=script&lang=ts"
export * from "./suporte-pacientes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports